import { ClaimV2CornSchema } from '@eigtech/claims-v2-types';
import { JobCornSchema } from '@eigtech/restoration-types';
import { z } from 'zod';
import { InspectionCornSchema } from '../base.js';
import { NoteSchema } from '../entities/note.js';
export const GetInspectionNotesApiSchema = {
    params: z.object({
        entityId: z.union([ClaimV2CornSchema, JobCornSchema]),
        inspectionId: InspectionCornSchema,
    }),
    query: z.object({}),
    response: z.object({
        notes: z.array(NoteSchema),
    }),
};
export const GetInspectionNotesRequestSchema = GetInspectionNotesApiSchema.params.merge(GetInspectionNotesApiSchema.query);
